import { IconProps } from "../../types/IconType";

const PlusIcon = ({ width, height, color = "#5534DA" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M7.2416 8.75778H3.9561C3.74329 8.75778 3.5637 8.68459 3.41732 8.53822C3.27094 8.39184 3.19775 8.21225 3.19775 7.99945C3.19775 7.78665 3.27094 7.60706 3.41732 7.46068C3.5637 7.3143 3.74329 7.24112 3.9561 7.24112H7.2416V3.95562C7.2416 3.7428 7.31479 3.56321 7.46117 3.41683C7.60755 3.27045 7.78714 3.19727 7.99994 3.19727C8.21274 3.19727 8.39233 3.27045 8.5387 3.41683C8.68508 3.56321 8.75827 3.7428 8.75827 3.95562V7.24112H12.0438C12.2566 7.24112 12.4362 7.3143 12.5826 7.46068C12.7289 7.60706 12.8021 7.78665 12.8021 7.99945C12.8021 8.21225 12.7289 8.39184 12.5826 8.53822C12.4362 8.68459 12.2566 8.75778 12.0438 8.75778H8.75827V12.0433C8.75827 12.2561 8.68508 12.4357 8.5387 12.5821C8.39233 12.7284 8.21274 12.8016 7.99994 12.8016C7.78714 12.8016 7.60755 12.7284 7.46117 12.5821C7.31479 12.4357 7.2416 12.2561 7.2416 12.0433V8.75778Z"
        fill={color}
      />
    </svg>
  );
};

export default PlusIcon;
